import React from 'react';
import { withDashboardLayout } from 'layouts/DashboardLayout/DashboardLayout';
import PageContainer from 'components/PageContainer/PageContainer';
import UploadShipments from 'components/UploadShipments/UploadShipments';
import useFileTypeUploadWarning from 'hooks/useFileTypeUploadWarning';

function UploadB2BPage() {
  const group = useFileTypeUploadWarning('b2b');

  return (
    <PageContainer title="Subida de archivos de B2B">
      <UploadShipments group={group} />
    </PageContainer>
  );
}

export default withDashboardLayout(UploadB2BPage);
